<template>
  <div class="filter">
    <div class="row">
      <div class="small-6 columns">
        <div class="search-box">
          <label class="field-label">Search:</label>
          <div class="search">
            <div class="search-input-box">
              <input type="text" v-model="searchInput"
                ref="search" :disabled="loading"
                v-on:keypress.enter="search" v-on:blur="blurSearch" />
                <!-- :disabled="loading" -->
              <transition name="slide-left">
                <i class="far fa-times-circle fa-lg" @click="clearSearch"
                  v-if="searchInput.length > 0"></i>
              </transition>
            </div>
            <button :class="{'button xsmall success':true, disabled:loading}"
              @click="search">
              <!-- 'disabled':loading -->
              <i class="fas fa-search fa-lg"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="small-3 columns end small-offset-3">
        <div class="status last">
          <label class="field-label">&nbsp;</label>
          <div class="flex">
            <a :class="{'button block cta small':true, 'disabled':loading}"
              href="/#/corporate/new">
              <i class="fas fa-plus"></i>
              CREATE
            </a>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import ApiCorporateList from '@/modules/api/corporate/list'

export default {
  name: 'list-filter',
  props: ['isMobile'],
  data () {
    return {
      searchInput: '',
      blurDelay: ''
    }
  },
  computed: {
    loading () { return this.$store.state.corporate.users.loading }
  },
  methods: {
    refreshTable () {
      let self = this
      if (self.loading) { return }

      self.$store.commit('corporate/resetUsers')
      self.$store.commit('corporate/setUserLoading', true)
      self.$store.commit('corporate/setUserCurrentPage', 1)

      ApiCorporateList.getList(self, res => {
        self.$store.commit('corporate/setUserLoading', false)
      })
    },
    search () {
      this.$store.commit('corporate/setUserSearch', this.searchInput)
      this.refreshTable()
    },
    blurSearch () {
      let self = this
      if (self.$store.state.corporate.users.search === self.searchInput.trim()) {
        return
      }

      self.blurDelay = setTimeout(function () {
        self.search()
      }, 500)
    },
    clearSearch () {
      if (this.blurDelay) { clearTimeout(this.blurDelay) }
      if (this.loading) { return }

      this.searchInput = ''
      this.$store.commit('corporate/setUserSearch', this.searchInput)
      this.refreshTable()
    },
  }
}
</script>

<style lang="scss" scoped>
.filter{
  padding: 10px;
  .row{ max-width: 100%; }
}

.field-label{
  font-size: 13px;
  color: #999;
  line-height: 1;
  display: block;
  margin-bottom: 4px;
}

.search-box{
  display: inline-block;
  padding: 20px 0 20px 15px;
  position: relative;
  width: 100%;

  .error-msg{
    position: absolute;
    bottom: 0;
    left: 0;
    width: calc(100% - 15px);
    padding: 2px 5px;
    font-size: 12px;
    text-align: center;
    margin-left: 15px;
    background: #ff6115;
    color: #fff;
    transform-origin: bottom center;
  }
}
.search{
  box-sizing: border-box;
  display: flex;
  width: 100%;

  .search-input-box{
    width: 100%;
    position: relative;

    input{
      display: inline-block;
      vertical-align: middle;
      margin-top: 0;
      border-radius: 5px 0 0 5px;
      padding-right: 30px;

      &.has-error{ border-color:#f33a27; }
    }
    i{
      position: absolute;
      top: 0;
      right: 5px;
      color: #d92626;
      cursor: pointer;
      line-height: 46px;
    }
  }
  button{
    display: inline-block;
    vertical-align: middle;
    line-height: 1;
    border-radius: 0 5px 5px 0;
    padding: 0 20px;
  }
}

.status{
  display: inline-block;
  padding: 20px 0 20px 15px;
  width: 100%;

  &.last{ padding-right: 10px; }
}

select{
  padding: 10px;
  height: 46px;
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: url('/assets/img/dropdown-arrow.png');
  background-repeat: no-repeat;
  background-position: right 50%;

  &[disabled]{ background-color: #ebebe4; }
}

.flex{
  display: flex;

  select{
    flex-grow: 100;
  }
}

.slide-left-enter-active, .slide-left-leave-active { transition: all .3s ease; }
.slide-left-enter, .slide-left-leave-to {
  transform: translateX(30px);
  opacity: 0;
}

@media only screen and (max-width: 430px) {
  .filter {
    padding: 0;
    .row {
      display: flex;
      .small-6 {
        width: 100%;
      }
      .small-3 {
        float: none;
        width: 50%;
        margin-left: 0;
        .status {
          padding: 24px 15px 20px 15px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Corporate/ListFilter.vue